import React from "react";
import { Box, useMediaQuery} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import WhyUs from "./whyUs";
import ContactForm from "./shared/contact/Contact";
import TermsAndConditionsDialog from "./TandC";

const ContactUsSection = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <div maxWidth='100vh' style={{overflow:"hidden"}}>
      <Box
        sx={{
          display: "flex",
          flexDirection: isSmallScreen ? "column" : "row",
          gap: 4,
          padding: 4,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Contact Form Section */}
        <Box
          sx={{
            flex: 1,
            maxWidth: isSmallScreen ? "100%" : "60%", // Full width on small screens, 45% on larger screens
            mt: isSmallScreen ? 4 : 0, // Adds margin-top for spacing on small screens
          }}
        >
          <ContactForm />
        </Box>
        <Box
          sx={{
            flex: 1,
            maxWidth: isSmallScreen ? "100%" : "60%", // Full width on small screens, 45% on larger screens
          }}
        >
          <WhyUs />
        </Box>
      </Box>
      <TermsAndConditionsDialog />
    </div>
  );
};

export default ContactUsSection;
